<div class="webview box box-custom">
  <!-- <p>{{billingRecord.desc}}</p> -->
  <ng-content select="[sample]"></ng-content>
</div>
